<template>
  <!-- name: '减碳值' -->
  <div class="carbonWrap">
    <div class="topBox">
      <span class="iconClass" @click="$router.go(-1)"></span>
      减碳值
    </div>
    <div class="logoBox">
      <img src="https://img.bbalt.cn/imgh5/userCenter/carbon_logo1.png" alt="" />
      <img src="https://img.bbalt.cn/imgh5/icon_fork.png" alt="" />
      <img src="https://img.bbalt.cn/imgh5/userCenter/carbon_logo2.png" alt="" />
    </div>
    <div class="sumBox">
      <span>您的累积减碳值</span>
      <span class="valueClass"
        ><span>{{ obj.totalCarbon }}</span
        >KG</span
      >
      <span class="timeClass">（截止{{ obj.date }}）</span>
    </div>

    <div class="numberBox">
      <div class="numberClass">
        <img
          src="https://img.bbalt.cn/imgh5/userCenter/icon_cloth.svg"
          alt=""
          class="iconClass"
        />
        <div class="infoClass">
          <span class="number">
            <span>{{ obj.clothsCount }}</span
            >件
          </span>
          <span class="text">衣物循环</span>
        </div>
        <img
          src="https://img.bbalt.cn/imgh5/userCenter/icon_arrow.svg"
          alt=""
          class="arrowClass"
        />
        <div class="infoClass">
          <span class="number">
            <span>{{ obj.clothsCarbon }}</span
            >g
          </span>
          <span class="text">获得减碳值</span>
        </div>
      </div>
      <span class="lineClass"></span>
      <div class="numberClass">
        <img
          src="https://img.bbalt.cn/imgh5/userCenter/icon_thing.svg"
          alt=""
          class="iconClass"
        />
        <div class="infoClass">
          <span class="number">
            <span>{{ obj.goodsCount }}</span
            >本
          </span>
          <span class="text">图书循环</span>
        </div>
        <img
          src="https://img.bbalt.cn/imgh5/userCenter/icon_arrow.svg"
          alt=""
          class="arrowClass"
        />
        <div class="infoClass">
          <span class="number">
            <span>{{ obj.goodsCarbon }}</span
            >g
          </span>
          <span class="text">获得减碳值</span>
        </div>
      </div>
    </div>
    <div class="tipBox">
      <img src="https://img.bbalt.cn/imgh5/userCenter/img_wheat.svg" alt="" />

      <p>
        丰云绿动碳减排量依据中华环保联合会制定的《公民绿色低碳行为温室气体减排量化导则》团体标准，以及绿普惠云的量化计算得出
      </p>
      <img src="https://img.bbalt.cn/imgh5/userCenter/img_wheat.svg" alt="" />
    </div>
  </div>
</template>

<script>
import { carbonReductionDetail } from "@/api/other.js";
export default {
  components: {},
  data() {
    return {
      obj: {},
    };
  },
  created() {
    this.getCarbonReductionDetail();
  },
  methods: {
    async getCarbonReductionDetail() {
      const { content } = await carbonReductionDetail();
      this.obj = content;
    },
  },
};
</script>

<style lang="scss" scoped>
.carbonWrap {
  height: 100%;
  width: 100%;
  background: #a0be5b;
  text-align: center;
  overflow: hidden;
  padding-bottom: 37px;
  display: flex;
  align-items: center;
  flex-flow: column;
  font-family: PingFang-SC, PingFang-SC;
  background-image: url("https://img.bbalt.cn/imgh5/userCenter/bg_carbon.svg");
  background-repeat: no-repeat;
  background-size: 100% 560px;
  .topBox {
    width: 100%;
    height: 96px;
    line-height: 96px;
    position: relative;
    font-size: 36px;
    font-weight: 400;
    color: #333333;
    .iconClass {
      position: absolute;
      top: 34px;
      left: 34px;
      &::before,
      &::after {
        position: absolute;
        content: "";
        border-top: 17px transparent dashed;
        border-left: 17px transparent dashed;
        border-bottom: 17px transparent dashed;
        border-right: 17px #fff solid;
      }
      &::before {
        border-right: 17px #333 solid;
      }
      &:after {
        left: 5px;
        border-right: 17px #e5f0f7 solid;
      }
    }
  }
  .logoBox {
    margin-top: 27px;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      &:first-child {
        width: 93px;
        height: 50px;
      }
      &:nth-child(2) {
        width: 26px;
        height: 26px;
        margin: 0px 15px;
      }
      &:last-child {
        width: 140px;
        height: 40px;
      }
    }
  }
  .sumBox {
    margin-top: 44px;
    width: 400px;
    height: 168px;
    background: rgba(255, 255, 255, 0.8);
    border-radius: 16px;
    border: 3px solid #ffffff;
    display: flex;
    flex-flow: column;
    justify-content: center;

    font-size: 26px;
    font-weight: 400;
    color: #666666;
    .valueClass {
      color: #333333;
      margin: 8px 0px;
      display: flex;
      justify-content: center;
      align-items: center;
      span {
        font-size: 44px;
        font-weight: 600;
        margin-right: 8px;
        display: inline-block;
        overflow: hidden;
        text-overflow: ellipsis;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        max-width: 80%;
      }
    }
    .timeClass {
      font-size: 22px;
      color: #999999;
    }
  }
  .numberBox {
    margin-top: 115px;
    width: 686px;
    height: 340px;
    background: #ffffff;
    border-radius: 24px;
    padding: 10px 0px;
    display: flex;
    flex-flow: column;
    justify-content: center;
    align-items: center;
    .numberClass {
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 36px 0px;
      .iconClass {
        width: 88px;
        height: 88px;
        margin-right: 24px;
      }
      .arrowClass {
        width: 26px;
        height: 21px;
      }
      .infoClass {
        display: flex;
        flex-flow: column;
        min-width: 200px;
        font-size: 24px;
        font-weight: 400;
        color: #666666;
        .number {
          font-size: 26px;
          color: #333333;
          margin-bottom: 8px;
          display: flex;
          justify-content: center;
          align-items: center;
          span {
            font-size: 36px;
            font-weight: bold;
            overflow: hidden;
            text-overflow: ellipsis;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
            max-width: 200px;
            display: inline-block;
          }
        }
      }
    }
    .lineClass {
      width: 600px;
      height: 1px;
      border-bottom: 1px solid #ededed;
      display: inline-block;
    }
  }
  .tipBox {
    margin: 20px 74px 0px 74px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 24px;
    font-weight: 400;
    color: #ffffff;
    line-height: 32px;
    img {
      width: 40px;
      height: 104px;
      margin: 0px 10px;
      &:last-child {
        transform: rotate(180deg);
      }
    }
  }
}
</style>
